<template>
    <h1 class="pageHeader">カードの状態について</h1>
    <section class="conditions_contents">
      <section>
        <h2>安心のカーナベル査定認定者</h2>
        <p>
          100時間以上の査定研修を行い選ばれたスタッフのみが”<strong>カーナベル査定認定者</strong>”となります。
        </p>
        <p>
          日々、査定者同士で『査定基準
          点数チェック』や『基準の目線合わせ』を行っているため、どの担当者の査定商品でも、同じ品質の商品をご提供しますのでご安心ください。
        </p>
        <img src="https://assets.ka-nabell.com/selling-web/pokemon/conditions/img-state01.jpg" alt="査定の様子" class="assessment_image" />
      </section>
      <section>
        <h2>状態ガイドライン</h2>
        <section class="guideline_contents">
          <p>
            当社では<strong>『S・A・B・C』４つの状態</strong>に分けて商品を提供しています。<br />コンディションの良いカードから、なるべく安いプレイ用のカードを購入したいお客様までニーズに合わせた商品をお選びいただけます。
          </p>
          <section class="guidelines">
            <div
              v-for="condition in conditions"
              class="situation"
              :class="`situation_${condition.rank}`"
            >
              <h3>
                <div class="conditionTitle">{{ condition.conditionTitle }}</div>
                <div>
                  <div v-for="(description, descIndex) in condition.conditionDescriptions"
                    :key="descIndex" class="conditionDescription">{{ description }}</div>
                </div>
              </h3>
              <div class="expansion">
                <Info />
                <p>各画像をタップで拡大してご確認いただけます</p>
              </div>
              <div class="example_images_wrapper">
                <div
                  v-for="example in condition.conditionExamples"
                  :key="example.exampleTitle"
                  class="example_image"
                >
                  <PMCardImage
                    :url="example.exampleImageUrl"
                    :alt="example.exampleTitle"
                    can-expand
                  />
                  <dl>
                    <dt>{{ example.exampleTitle }}</dt>
                    <dd>
                      <div v-for="(description, descIndex) in example.exampleDescriptions" :key="descIndex">{{ description }}</div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </section>
  
          <ul class="notice_list">
            <li>※上記見本は状態判断基準の一部になります</li>
            <li>※傷が写るように撮影角度や光の当て方を調整しています</li>
            <li>
              <span
                >※状態Sの中で「点数の高い商品が欲しい」といったご指定はいたしかねます</span
              >
            </li>
          </ul>
        </section>
      </section>
  
      <TextLink to="/pokemon" mode="arrow" text="ポケカ販売トップ" class="link_top"/>
    </section>
  </template>
  
  <script lang="ts">
  import { defineNuxtComponent} from '#app'
  import { Info } from '@ka-nabellinc/ka-nabell-icons'
  import { PMCardImage, TextLink } from "@ka-nabellinc/ka-nabell-ui";
  import { conditions } from './conditions';
  
  export default defineNuxtComponent({
    components: {
      Info,
      PMCardImage,
      TextLink
    },
    setup() {
      return {
        conditions
      }
    }
  })
  </script>
  
  <style scoped>
  .pageHeader {
    width: 100%;
  }

  .conditions_contents {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  
  .conditions_contents > section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .guideline_contents {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  
  .guidelines {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  
  p {
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0.14px;
  }
  
  .assessment_image {
    width: 100%;
  }
  
  .situation {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .situation h3 {
    margin: 0;
    font-size: 13px;
    padding: 12px 16px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0.13px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .situation.situation_s h3 {
    background: var(--primitive-colors-basic-lightblue-100);
    border-top: 2px var(--primitive-colors-basic-lightblue-500) solid;
  }
  .situation.situation_a h3 {
    background: var(--primitive-colors-system-green-100);
    border-top: 2px var(--primitive-colors-system-green-500) solid;
  }
  .situation.situation_b h3 {
    background: var(--primitive-colors-system-orange-100);
    border-top: 2px var(--primitive-colors-system-orange-500) solid;
  }
  .situation.situation_c h3 {
    background: var(--primitive-colors-system-red-100);
    border-top: 2px var(--primitive-colors-system-red-500) solid;
  }
  
  .situation h3 .conditionTitle {
    display: block;
    font-size: 15px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0.3px;
  }
  
  .situation.situation_s h3 .conditionTitle {
    color: #168ba4;
  }
  .situation.situation_a h3 .conditionTitle {
    color: #37a670;
  }
  .situation.situation_b h3 .conditionTitle {
    color: #d77c28;
  }
  .situation.situation_c h3 .conditionTitle {
    color: #bf304a;
  }
  
  .situation h3 .conditionDescription {
    font-size: 13px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0.13px;
  }
  
  .expansion {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 4px 20px;
  }
  .expansion svg path {
    width: 20px;
    height: 20px;
  }
  .expansion p {
    font-size: 10px;
    line-height: 160%;
    letter-spacing: 0.1px;
  }
  
  .example_images_wrapper {
    width: 100%;
    display: flex;
    column-gap: 12px;
    row-gap: 20px;
    flex-wrap: wrap;
    margin-bottom: 32px;
  }

  .example_image {
    width: calc((100% - (12px * 1)) / 2);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .example_image dl {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
  }
  .example_image dl dt {
    padding: 0;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.13px;
    line-height: 150%;
  }
  .situation_s .example_image dl dt {
    color: var(--primitive-colors-basic-lightblue-600);
  }
  .situation_a .example_image dl dt {
    color: var(--primitive-colors-system-green-600);
  }
  .situation_b .example_image dl dt {
    color: var(--primitive-colors-system-orange-600);
  }
  .situation_c .example_image dl dt {
    color: var(--primitive-colors-system-red-600);
  }
  .example_image dl dd {
    margin: 0;
    padding: 0;
    font-size: 11px;
    line-height: 160%;
    letter-spacing: 0.11px;
  }
  
  .notice_list {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .notice_list li {
    font-size: 12px;
    padding-left: 1em;
    text-indent: -1em;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.12px;
  }
  .notice_list li span {
    color: #f24141;
  }
  
  .link_top {
    align-self: center;
  }
  
  :deep(.TextLink .text) {
    /* NOTE: arrowアイコンとテキストを縦中央に揃える調整 */
    margin-bottom: 4px;
  }
  </style>
  